import React from "react";
import {Helmet} from "react-helmet";
import shape1 from "../../images/shape/heading-shape-1.png";
import shape2 from "../../images/shape/heading-shape-2.png";
import {Link} from 'react-router-dom'
import a from "../../images/project/neewee.webp";
import b from "../../images/project/freshee.webp";
import c from "../../images/project/sukhhi.webp";
import d from "../../images/project/snapmint.webp";
import e from '../../images/project/Hrone.webp';
import f from '../../images/project/medkart.png';
import g from '../../images/project/sunsure.webp';

let Case = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Case Study - Radixcap | Augmenting Value</title>
        <meta name="format-detection" content="telephone=no" />
        <link rel="canonical" href="http://radixcap.in/" />
      </Helmet>

      <div className="container pt-50 pb-50">
        <div className="row justify-content-center">
          <div className="col-xl-8 text-center">
            <div className="section-header mb-50 animate__animated animate__fadeInLeft animate__delay-1s animate__slow	2s">
              <h4 className="section-title mb-25">
                <span>
                  <img src={shape1} className="mr-10" alt="" />
                </span>
                Case Studies
                <span>
                  <img src={shape2} className="ml-10" alt="" />
                </span>
              </h4>
            </div>
          </div>
        </div>
        <hr />
        <div className="row animate__animated animate__fadeInUp animate__delay-4s animate__slow	2s" id="cardrrrr">
         
            <div className="col-lg-6 mt-40" id="carrrd">
            
              <div className="cardCase">
                <img src={a} alt="Avatar" className="image" />
                <div className="overlay">
                  <div>
                    <a href="/neewee" className="text">
                    Industrial Analytics company delivering Industry 4.0 benefits to clients across Manufacturing Industry </a>{" "}
                  </div>
                </div>
              </div>
             
            </div>
         
          
            <div className="col-lg-6 mt-40" id="carrrd">
           
              <div className="cardCase">
                <img src={d} alt="Avatar" className="image" />

                <div className="overlay">
                  <div>
                    <a href="/snapmint" className="text">
                    One of India's fastest growing Consumer Purchase Fintechs
                        </a>{" "}
                  </div>
                </div>
              </div>
              
            </div>
         
          
            <div className="col-lg-6 mt-40" id="carrrd">
            
              <div className="cardCase">
                <img src={c} alt="Avatar" className="image" />

                <div className="overlay">
                  <div>
                    <a href="/sukhhi" className="text">
                    Internet First Fashion Jewellery Brand
                    </a>{" "}
                  </div>
                </div>
              </div>
              
            </div>
          
          
            <div className="col-lg-6 mt-40" id="carrrd">
            
              <div className="cardCase">
                <img src={b} alt="Avatar" className="image" />
                <div className="overlay">
                  <div>
                    <a href="/freshee" className="text">
                    One of India's Largest Freshness & Hygiene Brands </a>{" "}
                  </div>
                </div>
              </div>
             
            </div>
         
         
            <div className="col-lg-6 mt-40" id="carrrd">
            
              <div className="cardCase">
                <img src={e} alt="Avatar" className="image" />
                <div className="overlay">
                  <div>
                    <a href="/hrone" className="text">
                    Mobile-first HRMS software with 127+ processes to simplify HR workday </a>{" "}
                  </div>
                </div>
              </div>
              
            </div>
         
         
            <div className="col-lg-6 mt-40" id="carrrd">
           
              <div className="cardCase">
                <img src={f} alt="Avatar" className="image" />
                <div className="overlay">
                  <div>
                    <a href="/fmedkart" className="text">
                    India's most trusted offline retail generic pharmacy chain with 7lac+ customers</a>{" "}
                  </div>
                </div>
              </div>
             
            </div>
          
          
            <div className="col-lg-6 mt-40" id="carrrd">
            
              <div className="cardCase">
                <img src={g} alt="Avatar" className="image" />
                <div className="overlay">
                  <div>
                    <a href="/sunsure" className="text">
                    India's leading renewable EPC company powering India's growth</a>{" "}
                  </div>
                </div>
              </div>
              
            </div>
         
        </div>
      </div>
    </>
  );
};
export default Case;
